import React from 'react';
import styled from 'styled-components';

const Display = styled.div`
  padding: 0.5em;
  color: #f54b3c;
  margin-top: 1em;
  line-height: 1.5em;
  text-align: center;
  border-radius: 4px;
  margin-bottom: 1em;
  font-family: Roboto;
  background-color: #f54b3c14;
  box-shadow: 0px 0px 0px 1px #f54b3c94;
`;

export const ErrorDisplay = ({ message }) => {
  if (!message) return null;

  return <Display>{message}</Display>;
};

export default ErrorDisplay;
